import { render } from "./BasicEmailAction.vue?vue&type=template&id=2dcd706a"
import script from "./BasicEmailAction.vue?vue&type=script&lang=js"
export * from "./BasicEmailAction.vue?vue&type=script&lang=js"

import "./BasicEmailAction.vue?vue&type=style&index=0&id=2dcd706a&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.29.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__